module.exports = __webpack_public_path__ + "img/download_apple.d49624e1.png";